import { render, staticRenderFns } from "./interface-time.vue?vue&type=template&id=0397c20d&"
import script from "./interface-time.vue?vue&type=script&lang=js&"
export * from "./interface-time.vue?vue&type=script&lang=js&"
import style0 from "./interface-time.vue?vue&type=style&index=0&id=0397c20d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports